<tt-page class="col-xs-12 col-md-4 sp-0">
    <tt-card>
        <tt-button-goto ttText="select_portal_user" ttGoto="selectportaluser" [ttGotoParms]="{ webpage: webPage, arg1: custactNo }" ttIcon="far fa-plus"></tt-button-goto>
    </tt-card>

    <tt-list [ttData]="itemsListMembers"></tt-list>
</tt-page>
